import React from 'react'
import { Carousel } from 'react-bootstrap'
import SliderImg1 from '../../Images/ImageSlider/EstablishedImg.jpg'
import SliderImg2 from '../../Images/ImageSlider/GeneralMeeting.jpg'
import SliderImg3 from '../../Images/ImageSlider/GroupPhoto.jpg'
import SliderImg4 from '../../Images/ImageSlider/AnniversaryPhoto.jpg'

const ImageSlider = () => {

    const sliderImg = [
        {
            id: '1',
            slideName: 'Annual-Group',
            slidePhoto: SliderImg1,
        },
        {
            id: '2',
            slideName: 'General-Meeting',
            slidePhoto: SliderImg2,
        },
        {
            id: '3',
            slideName: 'Training-Photo',
            slidePhoto: SliderImg3,
        },
        {
            id: '4',
            slideName: 'Anniversary',
            slidePhoto: SliderImg4,
        },
    ]

    return (
        <>
            <div className='slider-section'>
                <Carousel interval={4000} controls={false}>

                    {sliderImg.map((item, idx) => {
                        return (
                            <Carousel.Item key={idx}>
                                <img className="slide-img" src={item.slidePhoto} alt={item.slideName} crossOrigin='anonymous' />
                            </Carousel.Item>
                        )
                    })}

                </Carousel>
            </div>
        </>
    )
}

export default ImageSlider